import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { useEffect, useCallback } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { idFromPrefix } from '@@client/lib/forms';
import { useTokenCache } from '@@client/lib/hooks';
import { login as loginAction, loginClear } from '@@client/account/login/actions';
import LoginForm from '@@client/account/login/LoginForm';
import Messages from '@@client/components/Messages';
import Modal from '@@client/components/Modal';
import PrivacyTermsBrief from '@@client/components/PrivacyTermsBrief';

var mapStateToProps = function mapStateToProps(_ref) {
  var login = _ref.account.login;
  return {
    login: login
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      login: loginAction,
      loginClear: loginClear
    }, dispatch)
  };
};

var LoginModal = function LoginModal(_ref2) {
  var actions = _ref2.actions,
      login = _ref2.login,
      isOpen = _ref2.isOpen,
      onClose = _ref2.onClose,
      onRegisterClick = _ref2.onRegisterClick,
      onRecoverClick = _ref2.onRecoverClick;
  var tokenCache = useTokenCache();
  useEffect(function () {
    actions.loginClear();
  }, [isOpen]);
  var handleSubmit = useCallback(function (params) {
    // already logging in
    if (login.doing) return;
    actions.login(tokenCache, params).then(function (success) {
      if (success) onClose();
    });
  }, [login]);

  var footer = /*#__PURE__*/_jsxs(_Fragment, {
    children: ["Don't have an account? ", /*#__PURE__*/_jsx("button", {
      className: "m--as-link",
      onClick: onRegisterClick,
      children: "Create one"
    })]
  });

  var idPrefix = 'login-modal';
  return /*#__PURE__*/_jsxs(Modal, {
    initialFocus: '#' + idFromPrefix(idPrefix, 'email'),
    isOpen: isOpen,
    onClose: onClose,
    title: "Welcome to Autowrecking.com",
    subtitle: "Log in to your account to see your saved parts, vehicles, and more.",
    footer: footer,
    children: [/*#__PURE__*/_jsxs("div", {
      className: "jsx-3097808425" + " " + 'container',
      children: [/*#__PURE__*/_jsx(Messages, {
        error: login.errors
      }), /*#__PURE__*/_jsx(LoginForm, {
        idPrefix: "login-modal",
        onSubmit: handleSubmit,
        paramErrors: login.paramErrors,
        disabled: login.doing
      }), /*#__PURE__*/_jsx("p", {
        className: "jsx-3097808425" + " " + 'm--center',
        children: /*#__PURE__*/_jsx("button", {
          onClick: onRecoverClick,
          className: "jsx-3097808425" + " " + 'm--as-link',
          children: "Forgot your password?"
        })
      }), /*#__PURE__*/_jsx(PrivacyTermsBrief, {
        className: "m--center"
      })]
    }), /*#__PURE__*/_jsx(_JSXStyle, {
      id: "3097808425",
      children: [".container.jsx-3097808425 .actions{text-align:center;}", ".container.jsx-3097808425 .actions button{padding-left:80px;padding-right:80px;}"]
    })]
  });
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginModal);